import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appPriceTotalWallet]',
})
export class PriceTotalWalletDirective {

  constructor(public viewContainerRef: ViewContainerRef)
  {}



}
